export const EVENT_PLACEHOLDER_IMAGE = "/images/event-placeholder.webp";
export const PRODUCT_PLACEHOLDER_IMAGE = "/images/product-placeholder.webp";
export const NOT_FOUND_ILLUSTRATION = "/images/404-broken-logo.webp";

export function resolveProductImageUrl(
  ...candidates: Array<string | null | undefined>
): string {
  for (const src of candidates) {
    const trimmed = src?.trim();
    if (trimmed) return trimmed;
  }
  return PRODUCT_PLACEHOLDER_IMAGE;
}

export function productCoverUrl(product: {
  image_url?: string | null;
  product_images?: Array<{ image_url?: string | null; sort_order?: number | null }> | null;
}): string {
  const gallery = [...(product.product_images ?? [])].sort(
    (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0),
  );
  return resolveProductImageUrl(product.image_url, gallery[0]?.image_url);
}

export function resolveEventCoverUrl(src?: string | null): string {
  const trimmed = src?.trim();
  return trimmed || EVENT_PLACEHOLDER_IMAGE;
}

export function resolveEventCoverAbsoluteUrl(
  src?: string | null,
  origin = typeof window !== "undefined" ? window.location.origin : "https://tickethall.com",
): string {
  const resolved = resolveEventCoverUrl(src);
  if (/^(f|ht)tps?:\/\//i.test(resolved)) return resolved;
  return `${origin}${resolved.startsWith("/") ? resolved : `/${resolved}`}`;
}
